import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '../../../../../../common/hoc/withStyles';
import storeSpecialBannerStyle, {
  StyledStoreDetailBanner,
} from '../styles/StoreSpecialBanner.style'; // Import the CSS file for styling

const StoreDetailBanner = ({ className, shouldShowStoreSpecialBanner }) => {
  const { Header, StoreEvent, BannerColor, FontColor } = shouldShowStoreSpecialBanner;
  const tncLink = shouldShowStoreSpecialBanner['tnc-link'] || {};
  const { value, url } = tncLink;
  return (
    <StyledStoreDetailBanner BannerColor={BannerColor} FontColor={FontColor}>
      <div className={`${className} banner-content`}>
        <p className="banner-heading">{Header}</p>
        <div className="banner-body">
          <p className="banner-title">{StoreEvent}</p>
          <a href={url} className="terms-link" target={'_blank'} rel={'noopener noreferrer'}>
            {value}
          </a>
        </div>
      </div>
    </StyledStoreDetailBanner>
  );
};

StoreDetailBanner.defaultProps = {
  className: '',
};

StoreDetailBanner.propTypes = {
  className: PropTypes.string,
  shouldShowStoreSpecialBanner: PropTypes.shape({
    Header: PropTypes.string.isRequired,
    StoreEvent: PropTypes.string.isRequired,
    BannerColor: PropTypes.string,
    FontColor: PropTypes.string,
    'tnc-link': PropTypes.shape({
      value: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default withStyles(StoreDetailBanner, storeSpecialBannerStyle);
